export default {
    'name': 'Skygo Wifi Dashboard',
    'server_url': 'https://server.skygowifi.com',
    'server_api_url': 'https://server.skygowifi.com/api',
}